var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup153(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_67_296",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48 0H0V48H48V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_67_296)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 23.9442C0 10.7163 10.7163 0 23.9442 0C37.1721 0 47.8884 10.7163 47.8884 23.9442C47.8884 37.1721 37.1721 47.8884 23.9442 47.8884C10.7163 47.8605 0 37.1442 0 23.9442Z",
    fill: "#5865F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.7163 14.2045C32.6791 13.2835 30.5582 12.6138 28.3535 12.251C28.0745 12.7533 27.7675 13.3952 27.5442 13.9254C25.2 13.5626 22.8279 13.5626 20.4838 13.9254C20.2326 13.3393 19.9535 12.7812 19.6466 12.251C17.4419 12.6138 15.2931 13.2835 13.2838 14.2324C9.26516 20.2324 8.17678 26.0649 8.70702 31.8417C11.0791 33.5998 13.7024 34.9393 16.521 35.7766C17.1628 34.9114 17.721 34.0184 18.1954 33.0696C17.2745 32.7347 16.4093 32.3161 15.5721 31.8138C15.7954 31.6463 15.9907 31.4789 16.214 31.3114C21.1535 33.6556 26.9024 33.6556 31.8419 31.3114C32.0652 31.4789 32.2605 31.6463 32.4838 31.8138C31.6465 32.3161 30.7535 32.7347 29.8326 33.0696C30.307 34.0184 30.8652 34.9114 31.507 35.7766C34.3256 34.9114 36.9768 33.5998 39.321 31.8417C39.9349 25.144 38.2047 19.3393 34.7163 14.2045ZM18.8652 28.2696C17.3303 28.2696 16.1024 26.8742 16.1024 25.1719C16.1024 23.4696 17.3303 22.0463 18.8652 22.0463C20.4279 22.0463 21.6559 23.4417 21.6559 25.1719C21.6279 26.8742 20.4279 28.2696 18.8652 28.2696ZM29.1349 28.2696C27.6 28.2696 26.3721 26.8742 26.3721 25.1719C26.3721 23.4696 27.6 22.0463 29.1349 22.0463C30.6977 22.0463 31.9256 23.4417 31.8977 25.1719C31.8698 26.9021 30.6698 28.2696 29.1349 28.2696Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup153);
export default __webpack_public_path__ + "static/media/Group 153.076c9e1c063c04e65fc83b6db5be9fc2.svg";
export { ForwardRef as ReactComponent };